
export const studentData = [
    {
        id : "100",
        name : "Arun",
        std : "10",
        mark : "72%",
        attendance : "86%"
    },
    {
        id : "101",
        name : "Akash",
        std : "11",
        mark : "76%",
        attendance : "81%"
    },
    {
        id : "102",
        name : "Hariharan",
        std : "12",
        mark : "90%",
        attendance : "94%"
    },
    {
        id : "103",
        name : "Shahul",
        std : "9",
        mark : "84%",
        attendance : "88%"
    },
    {
        id : "104",
        name : "Manikandan",
        std : "8",
        mark : "72%",
        attendance : "95%"
    },
    {
        id : "105",
        name : "Preethi",
        std : "10",
        mark : "82%",
        attendance : "91%"
    }
];

export const teacherData = [
    {
        id: "100",
        name : "Kumaran",
        subject : "Maths",
        contact : "9976875417",
        performance: "Good"
    },
    {
        id: "101",
        name : "Murugan",
        subject : "Computer",
        contact : "9876543210",
        performance: "Very Good"
    },
    {
        id: "102",
        name : "Sekar",
        subject : "Tamil",
        contact : "9554545482",
        performance: "Medium"
    },
    {
        id: "103",
        name : "Suthahar",
        subject : "Social",
        contact : "8723924109",
        performance: "Very Good"
    },
    {
        id: "104",
        name : "Salem",
        subject : "English",
        contact : "9250175420",
        performance: "Medium"
    },
    {
        id: "105",
        name : "Dharani",
        subject : "Chemistry",
        contact : "8369147309",
        performance: "Excelent"
    }
]